
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/create",
      function () {
        return require("private-next-pages/book/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/create"])
      });
    }
  